import React, { useContext, useEffect, useMemo, useState } from "react";
import style from "./chatUserList.module.css";
import { useTranslation } from "react-i18next";
import { Dropdown, Menu, Spin, Tooltip } from "antd";
import useFetch, { CachePolicies } from "use-http";
import { useNavigate } from "react-router-dom";
import { LoadingOutlined, UserSwitchOutlined } from "@ant-design/icons";
import styles from "../../../Home/Post/PostCard.module.scss";
// icon import
import Call from "src/assets/png/newIcon/Chat room/Call.png";
import VideoCall from "src/assets/png/newIcon/Chat room/VideoCall.png";
import wave from "src/assets/png/wave.png";
import settingImg from "src/assets/png/settings.png";

import { AppContext } from "src/pages/context/App.context";
import { ChatContext } from "src/pages/context/Chat.context";
import Member, { promoteRole } from "./Member";
import { pathRoutes } from "../../../../props/util.props";
import { width } from "./Chat.const";
import CenterConfirmModal from "src/components/shared/Modal/CenterConfirmModal";
import { checkMobile } from "src/service/util.service";
import ButtonCenterCLose from "src/components/shared/button/CloseButton/ButtonCenterClose";
import { camSearchParam } from '../../../videoCall/VideoConference/utils/janusUtils';
import { isTrue } from "src/utils/janus.utils";
import { useAppSelector } from "src/hooks";
import { profile } from "src/features/profile/profileSlice";
import { MemberRole } from "../../../../constants/Member";

const ChatUserList = (props: any) => {
  const { t } = useTranslation();
  const myProfile = useAppSelector(profile);
  const appCtx: any = useContext(AppContext);
  const chatCtx: any = useContext(ChatContext);
  const navigate = useNavigate();
  const { members, chatId, onLeave, isGroup } = props;
  const leaveGroupAPI = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "/api/v2/groups",
    {
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );

  const [showLeaveModal, setShowLeaveModal] = useState(false);
  const [leaving, setLeaving] = useState(false);
  const [isGroupVoice, setIsGroupVoice] = useState(false);
  const [isGroupVideoCall, setIsGroupVideoCall] = useState(false);

  const memberFilter: any = useMemo(() => {
    return members.filter((member: any) => {
      return member?.userID !== myProfile.id;
    });
  }, [members]);

  const me: any = useMemo(() => {
    return members.find((member: any) => {
      return member?.userID === myProfile.id;
    });
  }, [members]);

  const myRole = me?.memberRole;
  console.log("role me?.role", myRole);

  const handleShowModal = () => {
    setShowLeaveModal(true);
  };

  const handleVideoCall = () => {
    if (isGroup) {
      navigate(pathRoutes.conference + "?id=" + chatId + "&" + camSearchParam + "=true");
    } else {
      navigate(pathRoutes.personalCall + "?id=" + chatId + "&isVideoCall=true");
    }
  };

  const handleVoiceCall = () => {
    if (isGroup) {
      navigate(pathRoutes.conference + "?id=" + chatId + "&" + camSearchParam + "=false");
    } else {
      navigate(
        pathRoutes.personalCall + "?id=" + chatId + "&isVideoCall=false"
      );
    }
  };

  const handleCancelLeave = () => {
    setShowLeaveModal(false);
  };

  const handlePromoteMember = (role: string) => {
    chatCtx.setPromoteMember(role);
  };

  const leaveGroup = async () => {
    setLeaving(true);
    try {
      await leaveGroupAPI.post(`/leave`, {
        groupID: chatId,
        userID: myProfile.id,
      });
      chatCtx.setShowUserDetail(false);
      chatCtx.setShowUserList(false);
      await onLeave();
      navigate("/center-chat");
    } catch (error) {
      console.error(error);
    }
  };

  const roleOwner: boolean = useMemo(() => {
    return myRole === MemberRole.OWNER && myProfile?.id === me?.user.id
  }, [myRole])

  const roleAdmin: boolean = useMemo(() => {
    return myRole === MemberRole.ADMIN && myProfile?.id === me?.user.id
  }, [myRole])

  const canRemoveMember: boolean = useMemo(() => {
    return (myRole === MemberRole.OWNER || myRole === MemberRole.ADMIN) && myProfile?.id === me?.user.id;
  }, [myRole])

  const renderOptions = useMemo(() => {
    if ((roleOwner || roleAdmin) && isGroup && myProfile?.id === me?.user.id) {
      return (
        <div className={style.option}>
          <div>
            <Dropdown
              overlay={
                <Menu>
                  {roleOwner &&
                    <Menu.Item
                      className={styles.menuItem}
                      onClick={() => {
                        handlePromoteMember(promoteRole.owner);
                      }}
                    >
                      <div style={{ display: "flex" }}>
                        <div
                          style={{
                            margin: "auto",
                          }}
                        >
                          {t("Promote Owner")}
                        </div>
                      </div>
                    </Menu.Item>
                  }
                  {roleOwner &&
                    <Menu.Item
                      className={styles.menuItem}
                      onClick={() => {
                        handlePromoteMember(promoteRole.admin);
                      }}
                    >
                      <div style={{ display: "flex" }}>
                        <div
                          style={{
                            margin: "auto",
                          }}
                        >
                          {t("Promote Admin")}
                        </div>
                      </div>
                    </Menu.Item>
                  }
                  {roleOwner &&
                    <Menu.Item
                      className={styles.menuItem}
                      onClick={() => {
                        handlePromoteMember(promoteRole.removeAdmin);
                      }}
                    >
                      <div style={{ display: "flex" }}>
                        <div
                          style={{
                            margin: "auto",
                          }}
                        >
                          {t("Remove Admin")}
                        </div>
                      </div>
                    </Menu.Item>
                  }
                  {canRemoveMember &&
                    <Menu.Item
                      className={styles.menuItem}
                      onClick={() => {
                        handlePromoteMember(promoteRole.removeMember);
                      }}
                    >
                      <div style={{ display: "flex" }}>
                        <div
                          style={{
                            margin: "auto",
                          }}
                        >
                          {t("Remove User")}
                        </div>
                      </div>
                    </Menu.Item>
                  }
                </Menu>
              }
              placement="bottomRight"
              arrow
              trigger={["click"]}
            >
              <img src={settingImg} width="20" style={{ cursor: "pointer" }} />
            </Dropdown>
          </div>
        </div>)
    }
  }, [myProfile, myRole, isGroup, memberFilter, canRemoveMember, roleOwner, roleAdmin])



  useEffect(() => {
    if (!appCtx.objectAccesses) return;
    setIsGroupVoice(appCtx.objectAccesses?.["GROUP_VOICE_CALL"]);
    setIsGroupVideoCall(appCtx.objectAccesses?.["GROUP_VIDEO_CALL"]);

    console.log("::>>>", appCtx.objectAccesses?.["GROUP_VIDEO_CALL"]);
    console.log("::>>", appCtx.objectAccesses?.["GROUP_VOICE_CALL"]);
  }, [appCtx.objectAccesses]);

  useEffect(() => {
    return () => {
      leaveGroupAPI.abort();
    };
  }, []);
  return (
    <>
      <div
        className={style.chatUserList}
        style={{ width: checkMobile() ? "100%" : `${width}px` }}
      >
        <CenterConfirmModal
          cancelText={t("Cancel")}
          confirmText={
            <>
              {leaving ? (
                <Spin
                  indicator={
                    <LoadingOutlined
                      style={{ fontSize: "20px", color: "#FFFFFF" }}
                    />
                  }
                />
              ) : (
                t("Ok")
              )}
            </>
          }
          text={t("Are you sure you want to Leave group?")}
          visible={showLeaveModal}
          onCancel={() => {
            handleCancelLeave();
          }}
          onConfirm={() => {
            leaveGroup();
          }}
        ></CenterConfirmModal>

        {/* <Modal
        visible={showLeaveModal}
        onOk={leaveGroup}
        onCancel={handleCancelLeave}
        className={style.modalOveride}
      >
        <div
          onClick={handleCancelLeave}
          className={style.closeBtn}
          style={{ backgroundImage: `url(${crossIcon})` }}
        />
        <div className={style.leaveModalContainer}>
          <div className={style.leaveGroupHeader}>{t("Leave Group")}</div>
          <div className={style.leaveGroupDetail}>
            {t("Are you sure you want to Leave group?")}
          </div>
          <div className={style.leaveModalBtnContainer}>
            <div className={style.cancelLeaveBtn} onClick={handleCancelLeave}>
              {t("Cancel")}
            </div>
            <div className={style.confirmLeaveBtn} onClick={leaveGroup}>
              {leaving ? (
                <Spin
                  indicator={
                    <LoadingOutlined
                      style={{ fontSize: "20px", color: "#FFFFFF" }}
                    />
                  }
                />
              ) : (
                t("Ok")
              )}
              <div></div>
            </div>
            <div>for last child bug</div>
          </div>
          <div>for last child bug</div>
        </div>
        <div>for last child bug</div>
      </Modal> */}
        <div className={style.contentContainer}>
          <div
            className={style.backButton}
            style={{ position: "absolute", left: "15px", top: "10px" }}
            onClick={() => {
              chatCtx.setShowUserList(false);
            }}
          >
            <ButtonCenterCLose></ButtonCenterCLose>
          </div>
          <div className={style.topBottonsContainer}>
            {/* HideNotComplete*/}
            {/* <div className={style.bottonContainer}>
            <Tooltip
              placement="bottom"
              title={t("Invite Friend")}
              color="#0f4c82"
            >
              <button type="button" className={style.topButton}>
                <div
                  className={style.bluePlus}
                  style={{ backgroundImage: `url(${bluePlus})` }}
                />
              </button>
            </Tooltip>
            <div className={style.topButtonLabel}>{t("Invite Friend")}</div>
          </div> */}

            {isTrue(isGroupVoice) && (
              <div className={style.bottonContainer}>
                <Tooltip placement="bottom" title={t("Call")} color="#0f4c82">
                  <button
                    type="button"
                    className={style.topButton}
                    onClick={handleVoiceCall}
                  >
                    <div
                      className={style.call}
                      style={{ backgroundImage: `url(${Call})` }}
                    />
                  </button>
                </Tooltip>
                {/* <div className={style.topButtonLabel}>
                {t("Video Conference")}
              </div> */}
              </div>
            )}

            {isTrue(isGroupVideoCall) && (
              <div className={style.bottonContainer}>
                <Tooltip
                  placement="bottom"
                  title={t("Video Conference")}
                  color="#0f4c82"
                >
                  <button
                    type="button"
                    className={style.topButton}
                    onClick={handleVideoCall}
                  >
                    <div
                      className={style.videoCall}
                      style={{ backgroundImage: `url(${VideoCall})` }}
                    />
                  </button>
                </Tooltip>
                {/* <div className={style.topButtonLabel}>
                {t("Video Conference")}
              </div> */}
              </div>
            )}
            {isGroup && (
              <div className={style.bottonContainer}>
                <Tooltip placement="bottom" title={t("Leave")} color="#0f4c82">
                  <button
                    type="button"
                    className={style.topButton}
                    onClick={handleShowModal}
                  >
                    <div
                      className={style.wave}
                      style={{ backgroundImage: `url(${wave})` }}
                    />
                  </button>
                </Tooltip>
                {/* <div className={style.topButtonLabel}>{t("Leave")}</div> */}
              </div>
            )}
          </div>
          <div className={style.memberHeader}>
            {t("Members")} ({members?.length})
            {renderOptions}
          </div>
          <div className={style.memberListContainer}>
            <Member
              role={me?.memberRole}
              data={me?.user}
              isGroup={isGroup}
              context={chatCtx}
            />
            {memberFilter?.map((member: any, idx: number) => {
              return (
                <Member
                  key={idx}
                  myRole={me?.memberRole}
                  role={member?.memberRole}
                  data={member.user}
                  isGroup={isGroup}
                  context={chatCtx}
                />
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default ChatUserList;
